import { __decorate } from "tslib";
import { FormRadio } from '../radio/element';
import { CheckErrorMsg } from '../../../../lib/validate/checkErrorMsg';
import { CheckedElement } from '../../../../lib/validate/checkedElement';
import { queryAssignedNodes } from 'lit/decorators.js';
import '../../../atom/checkbox/element';
export class FormCheckbox extends FormRadio {
    constructor() {
        super(...arguments);
        this.type = 'checkbox';
        this.validator = new CheckedElement(this);
    }
    firstUpdated() {
        super.firstUpdated();
        this.slotElements = this._slot.assignedNodes();
        this.defineFor();
        this._slot.addEventListener('slotchange', (e) => {
            e.stopImmediatePropagation();
            this._updateItems();
        });
    }
    defineFor() {
        this.setAttribute('name', this.name);
        this.slotElements.forEach((node) => {
            if (node instanceof Text) {
                return;
            }
            if (node.nodeName == 'EP-CHECKBOX') {
                node.setAttribute('name', this.name);
            }
        });
    }
    change(e) {
        e.stopImmediatePropagation();
        const value = [];
        this.value = '';
        for (let i = 0; i < this._checkboxes.length; i++) {
            if (this._checkboxes[i] instanceof Text) {
                continue;
            }
            const input = this._checkboxes[i].shadowRoot.querySelector('input');
            if (input.checked || this._checkboxes[i].checked) {
                this._checkboxes[i].setAttribute('checked', '');
                value.push(input.value);
            }
            if (!input.checked && !this._checkboxes[i].checked) {
                this._checkboxes[i].removeAttribute('checked');
            }
        }
        this.value = String(value);
        new CheckErrorMsg(this).checkErrorMsg(this.validator.getValidator());
        const target = e.target;
        const cEvent = new CustomEvent('changeExtended', {
            composed: true,
            bubbles: true,
            detail: {
                value: value,
                elm: target,
                parent: this
            }
        });
        if (target._input != undefined) {
            this.dispatchEvent(new CustomEvent('change', {
                composed: true,
                bubbles: true,
                detail: this.value
            }));
            target.dispatchEvent(cEvent);
        }
    }
}
__decorate([
    queryAssignedNodes()
], FormCheckbox.prototype, "_checkboxes", void 0);
if (!customElements.get('ep-form-checkbox')) {
    customElements.define('ep-form-checkbox', FormCheckbox);
}
//# sourceMappingURL=element.js.map